


import { useEffect, useState } from "react";
import { getLoggedinUser } from "../../helpers/api_helper";

const useProfile = () => {
  const userProfileSession = getLoggedinUser();
  const token = userProfileSession?.data?.token;
  const [loading, setLoading] = useState(!!token ? false : true);
  const [userProfile, setUserProfile] = useState(userProfileSession?.data || null);

  useEffect(() => {
    const userProfileSession = getLoggedinUser();
    const token = userProfileSession?.data?.token;
    setUserProfile(userProfileSession?.data || null);
    setLoading(!!token ? false : true);
  }, []);

  return { userProfile, loading, token };
};

export { useProfile };
